import {
  fetchNumbers,
  fetchIdentities,
  setPrimiaryNumber,
  deleteNumber as deleteUserNumber,
  addNumber as addUserNumber,
  verifyNumberBySMS as verifyUserNumberBySMS,
  verifyNumberByCall as verifyUserNumberByCall,
  verifyNumberWithRecivedCode as verifyUserNumberWithRecivedCode
} from '@/api/user'

import {
  fetchCallerRegions,
  putCallerRegion
} from '@/api/calling'
/**
* Fetch user behavior from API
*/
const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('FETCH_NUMBERS_SUBMIT')

    fetchNumbers()
      .then((response) => {
        if (response) {
          commit('FETCH_NUMBERS_RESPONSE', response)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('FETCH_NUMBERS_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Set number as users primary
*/
const setAsPrimary = async ({ commit }, endpoint) => {
  return new Promise((resolve, reject) => {
    commit('SET_NUMBER_AS_PRIMARY_SUBMIT')

    setPrimiaryNumber(endpoint)
      .then((response) => {
        if (response) {
          commit('SET_NUMBER_AS_PRIMARY_RESPONSE', endpoint)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_NUMBER_AS_PRIMARY_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Delete a user number
*/
const deleteNumber = async ({ commit }, endpoint) => {
  return new Promise((resolve, reject) => {
    commit('DELETE_NUMBER_SUBMIT')

    deleteUserNumber(endpoint)
      .then((response) => {
        if (response) {
          commit('DELETE_NUMBER_RESPONSE', endpoint)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('DELETE_NUMBER_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Get caller regions for a number
*/
const getCallerRegions = async ({ commit }, number) => {
  commit('GET_CALLER_REGIONS_SUBMIT')

  try {
    let response = await fetchCallerRegions(number.countryId)

    if (response) {
      commit('GET_CALLER_REGIONS_RESPONSE', response, number)
      return true
    } else {
      throw Error('No response from server')
    }
  } catch (error) {
    commit('GET_CALLER_REGIONS_ERROR_RESPONSE')
    return false
  }
}

/**
* Set caller region for a user
*/
const setCallerRegion = async ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit('SET_CALLER_REGION_SUBMIT')

    putCallerRegion({ endpoint: data.number.endpoint, areaId: data.areaId })
      .then((response) => {
        if (response) {
          commit('SET_CALLER_REGION_RESPONSE', response)
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('SET_CALLER_REGION_ERROR_RESPONSE')
        reject(error)
      })
  })
}
/**
* Add number for a user
*/
const addNumber = async ({ commit }, number) => {
  return new Promise((resolve, reject) => {
    commit('ADD_NUMBER_SUBMIT')

    addUserNumber(number)
      .then((response) => {
        if (response) {
          commit('ADD_NUMBER_RESPONSE', response)
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('ADD_NUMBER_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Add number for a user
*/
const verifyNumberBySMS = async ({ commit }, endpoint) => {
  return new Promise((resolve, reject) => {
    commit('VERIFY_NUMBER_BY_SMS_SUBMIT')

    verifyUserNumberBySMS(endpoint)
      .then((response) => {
        if (response) {
          commit('VERIFY_NUMBER_BY_SMS_RESPONSE', response)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('VERIFY_NUMBER_BY_SMS_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Add number for a user
*/
const verifyNumberWithRecivedCode = async ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit('VERIFY_NUMBER_RECIVED_CODE_SUBMIT')

    verifyUserNumberWithRecivedCode(data)
      .then((response) => {
        if (response) {
          commit('VERIFY_NUMBER_RECIVED_CODE_RESPONSE', response)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('VERIFY_NUMBER_RECIVED_CODE_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Add number for a user
*/
const verifyNumberByCall = async ({ commit, dispatch }, number) => {
  return new Promise((resolve, reject) => {
    commit('VERIFY_NUMBER_BY_CALL_SUBMIT')

    verifyUserNumberByCall(number.endpoint)
      .then((response) => {
        if (response) {
          commit('VERIFY_NUMBER_BY_CALL_RESPONSE', response)
          commit('START_VERIFY_NUMBER_BY_CALL')
          dispatch('checkIfNumberIsVerifiedByCall', number)
          resolve(true)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('VERIFY_NUMBER_BY_CALL_ERROR_RESPONSE')
        reject(error)
      })
  })
}

const checkIfNumberIsVerifiedByCall = async ({ commit, state, dispatch }, number) => {
  try {
    if (!state.verifyByCallCallingInProgress) return

    commit('VERIFY_NUMBER_BY_CALL_VERIFIED_COUNTER')
    const response = await fetchIdentities(number)
    if (!response.errors) {
      let validated = false
      for (var i in response) {
        const numberToCheck = response[i]
        if (numberToCheck.endpoint === number.endpoint && numberToCheck.verified) {
          validated = true
        }
      }
      if (validated) {
        commit('VERIFY_NUMBER_BY_CALL_VERIFIED', number)
      } else if (state.checkVerifyNumberByCallCounter < 30) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        dispatch('checkIfNumberIsVerifiedByCall', number)
      } else {
        commit('VERIFY_NUMBER_BY_CALL_VERIFIED_FAILED', 'timeout')
      }
    } else {
      throw response.errors
    }
  } catch (error) {
    commit('VERIFY_NUMBER_BY_CALL_VERIFIED_FAILED', error)
    throw error
  }
}

const cancelVerifyNumberByCall = async ({ commit, state, dispatch }, number) => {
  commit('CANCEL_VERIFY_NUMBER_BY_CALL')
}

export default {
  fetch,
  deleteNumber,
  setAsPrimary,
  getCallerRegions,
  setCallerRegion,
  addNumber,
  verifyNumberBySMS,
  verifyNumberByCall,
  verifyNumberWithRecivedCode,
  checkIfNumberIsVerifiedByCall,
  cancelVerifyNumberByCall
}



// WEBPACK FOOTER //
// ./src/store/modules/user/numbers/actions.js